export default __webpack_public_path__ + "static/media/bootstrap.28dfcb88.png";